export default "/assets/images/mila-feed-09.mp4?7789522fe1a57cfc15aece028f568ee0";